// ========================================
// COMPONENTS / HeroSlider.jsx — image only
// ========================================

import React from "react";
import { useAutoSlide } from "../hooks";
import styles from "./HeroSlider.module.css";

const SLIDES = [
  { src: "/1st slider.png", alt: "Corporate & Promotional Gifts" },
  { src: "/2nd slider.png", alt: "Little Things Matter — Moments Become Magical" },
  { src: "/3rd slider.png", alt: "Everyday Made Beautiful" },
];

export default function HeroSlider() {
  const { current, goTo } = useAutoSlide(SLIDES.length, 4500);

  return (
    <section className={styles.hero}>
      {SLIDES.map((slide, i) => (
        <img
          key={slide.src}
          src={slide.src}
          alt={slide.alt}
          className={`${styles.slide} ${i === current ? styles.slideActive : ""}`}
          draggable={false}
        />
      ))}

      <div className={styles.dots}>
        {SLIDES.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className={`${styles.dot} ${i === current ? styles.dotActive : ""}`}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
